import type {Container, ServiceIdentifier} from 'inversify';

import {injectable} from 'inversify';

@injectable()
export class ServiceLocator {
  private container: Container;

  get<T>(cls: ServiceIdentifier<T>): T {
    const hasTarget = this.container.isBound(cls);

    if (hasTarget) {
      return this.container.get(cls);
    } else {
      throw `NO TARGET FOR ${cls.toString()}`;
    }
  }

  setContainer(container: Container): void {
    this.container = container;
  }
}
